// Konwersje dat dla edycji completed_at / cancelled_at (spec/lista-zadan.md → "Data ukończenia / anulowania").
// Czysty moduł bez DOM — testowany w tests/unit/dates_test.ts.

export type DeadlineStatus = 'overdue' | 'today' | 'tomorrow' | null;

/** Lokalna data YYYY-MM-DD dla podanego momentu (domyślnie teraz). */
export function localDateISO(d: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/**
 * Status terminu względem dnia `today` (YYYY-MM-DD, lokalnie): 'overdue' = po terminie,
 * 'today' = mija dziś, 'tomorrow' = mija jutro, null = dalej / brak. Spec: lista-zadan.md → meta row.
 */
export function deadlineStatus(deadline: string | null, today: string): DeadlineStatus {
  if (!deadline) return null;
  const d = deadline.slice(0, 10);
  if (d < today) return 'overdue';
  if (d === today) return 'today';
  const [y, m, day] = today.split('-').map(Number);
  const tomorrow = localDateISO(new Date(y, m - 1, day + 1));
  if (d === tomorrow) return 'tomorrow';
  return null;
}

/** ISO timestamp → wartość dla <input type="date"> w czasie lokalnym (YYYY-MM-DD). */
export function isoToDateInput(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/**
 * YYYY-MM-DD z date pickera → ISO timestamp. Godzina brana z dotychczasowej wartości
 * (albo 12:00 lokalnie), żeby zmiana samego dnia nie przesuwała daty przez strefę czasową.
 */
export function dateInputToIso(ymd: string, prevIso: string | null): string {
  const [y, m, d] = ymd.split('-').map(Number);
  const prev = prevIso ? new Date(prevIso) : null;
  const hasPrev = prev !== null && !Number.isNaN(prev.getTime());
  const dt = new Date(y, m - 1, d, hasPrev ? prev!.getHours() : 12, hasPrev ? prev!.getMinutes() : 0, 0, 0);
  return dt.toISOString();
}
